import React from "react";

import t from "../../../Common/utils/translation/translator";

import AxisSelectionTableCollapsableHeaders from "./AxisSelectionTableCollapsableHeaders";

const AxisSelectionTableCollapsableHeadersSection = ({
  productLength,
  setProductLength,
  productExpand,
  setProductExpand,
  technicalFeatureLength,
  setTechnicalFeatureLength,
  technicalFeatureExpand,
  setTechnicalFeatureExpand,
  performanceOverviewLength,
  setPerformanceOverviewLength,
  performanceOverviewExpand,
  setPerformanceOverviewExpand,
  guidingSystemLength,
  setGuidingSystemLength,
  guidingSystemExpand,
  setGuidingSystemExpand,
  mechanics,
  productTableHeaders,
  technicalFeaturesTableHeaders,
  performanceOverviewTableHeaders,
  getGuidingSystemTableHeaders,
  ...props
}) => {
  return (
    <tr className="AxisSelectionTableCollapsableHeadersSection" {...props}>
      <th className="main py-3 px-1 text-transparent">.</th>
      <AxisSelectionTableCollapsableHeaders
        data-testid="axis-selection-table-collapsable-headers-product"
        title={t("cartesian.ui.axis_selection.product")}
        length={productLength}
        updateFunction={setProductLength}
        defaultValue={productTableHeaders?.length}
        expand={productExpand}
        expandFunction={setProductExpand}
      />
      <AxisSelectionTableCollapsableHeaders
        data-testid="axis-selection-table-collapsable-headers-technical_features"
        title={t("cartesian.ui.axis_selection.technical_features")}
        length={technicalFeatureLength}
        updateFunction={setTechnicalFeatureLength}
        defaultValue={technicalFeaturesTableHeaders?.length}
        expand={technicalFeatureExpand}
        expandFunction={setTechnicalFeatureExpand}
      />
      <AxisSelectionTableCollapsableHeaders
        data-testid="axis-selection-table-collapsable-headers-performance_overview"
        title={t("cartesian.ui.axis_selection.performance_overview")}
        length={performanceOverviewLength}
        updateFunction={setPerformanceOverviewLength}
        defaultValue={performanceOverviewTableHeaders?.length}
        expand={performanceOverviewExpand}
        expandFunction={setPerformanceOverviewExpand}
      />
      <AxisSelectionTableCollapsableHeaders
        data-testid="axis-selection-table-collapsable-headers-guiding_system"
        title={t("cartesian.ui.axis_selection.guiding_system")}
        length={guidingSystemLength}
        updateFunction={setGuidingSystemLength}
        defaultValue={getGuidingSystemTableHeaders(mechanics.quantityCarriages)?.length}
        expand={guidingSystemExpand}
        expandFunction={setGuidingSystemExpand}
      />
    </tr>
  );
};

export default AxisSelectionTableCollapsableHeadersSection;
